import React,{useEffect,useState} from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
import ProposalList from './ProposalList';

const ProposalSubmit = () => {
    const [proposalInfo,setProposalInfo] = useState(null);
    
    
    useEffect(() => {
        client
            .query({
                query: queries.proposal,
            })
            .then((response) => {
                const proposalDoc= response.data.allProposal_sus.edges[0].node;
                setProposalInfo(proposalDoc);
           
  
            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <div>
            <h3 className="subtitle ">{proposalInfo?.title[0]?.text}</h3>
            <p className="body-text">{proposalInfo?.description[0]?.text}</p>
            <div className="proposal-cotaint">
                <h5 className="robot-challenge-title pt-5">{proposalInfo?.sub_tilte[0]?.text}</h5>
                <p  className="body-text ">{proposalInfo?.sub_des[0]?.text}</p>
                {proposalInfo?.propos_info.map((proposalInfo, index) => <ProposalList key={index + 1} no={index} proposalInfo={proposalInfo}></ProposalList>)}


            </div>
            <div className="addition-info">
                <h5 className="pb-2 pt-5">{proposalInfo?.additional_title[0]?.text}</h5>


                <ol>
                    {proposalInfo?.addition_info.map((extaInfo, index) => <li className="body-text" key={index + 1}><span>{index + 1}.</span> {extaInfo?.info[0]?.text}</li>)}
                </ol>

            </div>
           
           
            <h5 className="robot-challenge-title pt-5">{proposalInfo?.eval_title[0]?.text}</h5>
            <p className="body-text ">{proposalInfo?.evel_des[0]?.text}</p>
            <h5 className="robot-challenge-title pt-5">{proposalInfo?.eligib_title[0]?.text}</h5>
            <p className="body-text">{proposalInfo?.eligible_des[0]?.text}</p>
        
        </div>
    );
};

export default ProposalSubmit;